var _g, _g2, _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSfpCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_294_2456)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 9,
    fill: "white",
    fillOpacity: 0.35
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_2456)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5124 34.2134V22.7569C47.5124 22.5399 47.3381 22.3518 47.1057 22.3518H17.8799C17.662 22.3518 17.4731 22.5254 17.4731 22.7569V44.326C17.4731 44.543 17.6475 44.731 17.8799 44.731H36.0791C36.0439 44.4596 36.0203 44.1846 36.0085 43.9065H18.3011V23.1619H46.6989V34.0748C46.9739 34.1094 47.2452 34.1558 47.5124 34.2134Z",
    fill: "#EA5462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5124 34.2134L47.407 34.7022L48.0124 34.8327V34.2134H47.5124ZM36.0791 44.731V45.231H36.6479L36.5749 44.6669L36.0791 44.731ZM36.0085 43.9065L36.5081 43.8854L36.4879 43.4065H36.0085V43.9065ZM18.3011 43.9065H17.8011V44.4065H18.3011V43.9065ZM18.3011 23.1619V22.6619H17.8011V23.1619H18.3011ZM46.6989 23.1619H47.1989V22.6619H46.6989V23.1619ZM46.6989 34.0748H46.1989V34.5158L46.6365 34.5709L46.6989 34.0748ZM47.0124 22.7569V34.2134H48.0124V22.7569H47.0124ZM47.1057 22.8518C47.0523 22.8518 47.0124 22.8063 47.0124 22.7569H48.0124C48.0124 22.2735 47.6239 21.8518 47.1057 21.8518V22.8518ZM17.8799 22.8518H47.1057V21.8518H17.8799V22.8518ZM17.9731 22.7569C17.9731 22.7821 17.9614 22.8085 17.9432 22.8261C17.9269 22.842 17.9045 22.8518 17.8799 22.8518V21.8518C17.3995 21.8518 16.9731 22.2358 16.9731 22.7569H17.9731ZM17.9731 44.326V22.7569H16.9731V44.326H17.9731ZM17.8799 44.231C17.9332 44.231 17.9731 44.2766 17.9731 44.326H16.9731C16.9731 44.8094 17.3617 45.231 17.8799 45.231V44.231ZM36.0791 44.231H17.8799V45.231H36.0791V44.231ZM36.5749 44.6669C36.5416 44.4097 36.5192 44.1491 36.5081 43.8854L35.509 43.9275C35.5213 44.2201 35.5462 44.5095 35.5832 44.7952L36.5749 44.6669ZM18.3011 44.4065H36.0085V43.4065H18.3011V44.4065ZM17.8011 23.1619V43.9065H18.8011V23.1619H17.8011ZM46.6989 22.6619H18.3011V23.6619H46.6989V22.6619ZM47.1989 34.0748V23.1619H46.1989V34.0748H47.1989ZM46.6365 34.5709C46.897 34.6037 47.154 34.6476 47.407 34.7022L47.6178 33.7246C47.3365 33.664 47.0509 33.6151 46.7614 33.5787L46.6365 34.5709Z",
    fill: "#EA5462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5194 42.4165C27.1472 42.4165 23.5884 38.8723 23.5884 34.5179C23.5884 30.1636 27.1472 26.6194 31.5194 26.6194C35.8917 26.6194 39.4505 30.1636 39.4505 34.5179C39.4505 38.8723 35.8917 42.4165 31.5194 42.4165ZM31.5194 27.4295C27.5975 27.4295 24.4163 30.6121 24.4163 34.5035C24.4163 38.3949 27.612 41.5774 31.5194 41.5774C35.4269 41.5774 38.6225 38.3949 38.6225 34.5035C38.6225 30.6121 35.4269 27.4295 31.5194 27.4295Z",
    fill: "#EA5462",
    stroke: "#EA5462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8109 21.0933H19.7827C19.5503 21.0933 19.376 20.9053 19.376 20.6883C19.376 20.4713 19.5648 20.2832 19.7827 20.2832H25.8254C26.0578 20.2832 26.2321 20.4713 26.2321 20.6883C26.2321 20.9053 26.0433 21.0933 25.8254 21.0933H25.8109Z",
    fill: "#EA5462",
    stroke: "#EA5462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9995 27.9793H39.8574C39.625 27.9793 39.4507 27.7912 39.4507 27.5742V25.0137C39.4507 24.7822 39.6395 24.6086 39.8574 24.6086H44.9995C45.2319 24.6086 45.4062 24.7967 45.4062 25.0137V27.5742C45.4062 27.8057 45.2174 27.9793 44.9995 27.9793ZM40.2641 27.1547H44.5928V25.4188H40.2641V27.1547Z",
    fill: "#EA5462",
    stroke: "#EA5462"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 43.5,
    r: 6.5,
    fill: "#EA5462"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 39V47",
    stroke: "#F4F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 43L42 43",
    stroke: "#F4F3F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_294_2456",
    x: -12,
    y: -12,
    width: 89,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_294_2456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_294_2456",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_2456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8495,
    height: 27.2581,
    fill: "white",
    transform: "translate(16.0752 18.8708)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfpCameraIcon);
export default __webpack_public_path__ + "static/media/sfp-camera-icon.b73e60602aa913c48df9e9fbc463f262.svg";
export { ForwardRef as ReactComponent };